<template>
  <Teleport to="body">
    <Transition name="appupdate-fade">
      <div
        v-if="update.state.updateRequired"
        class="appupdate-screen"
        dir="rtl"
        lang="ar"
        role="alertdialog"
        aria-live="assertive"
      >
        <div class="appupdate-screen__content">
          <img
            class="appupdate-screen__logo"
            src="@/assets/images/logo_navbar.png"
            alt="Mr.Tarek Maths"
          />

          <div class="appupdate-screen__emoji" aria-hidden="true">🚀</div>

          <h1 class="appupdate-screen__title">يتوفر إصدار جديد من التطبيق</h1>
          <p class="appupdate-screen__subtitle">
            {{ update.state.message || 'للاستمرار في استخدام التطبيق، يجب تحديث التطبيق إلى أحدث إصدار.' }}
          </p>

          <div class="appupdate-screen__versions">
            <div class="appupdate-screen__version">
              <span class="appupdate-screen__version-label">الإصدار الحالي</span>
              <span class="appupdate-screen__version-value appupdate-screen__version-value--old">
                {{ update.state.currentVersion || '—' }}
              </span>
            </div>
            <div class="appupdate-screen__version-arrow" aria-hidden="true">←</div>
            <div class="appupdate-screen__version">
              <span class="appupdate-screen__version-label">الإصدار المطلوب</span>
              <span class="appupdate-screen__version-value appupdate-screen__version-value--new">
                {{ update.state.requiredVersion || '—' }}
              </span>
            </div>
          </div>

          <div class="appupdate-screen__actions">
            <button
              type="button"
              class="appupdate-screen__btn appupdate-screen__btn--primary"
              @click="handleUpdate"
            >
              تحديث التطبيق
            </button>

            <button
              v-if="!update.state.forceUpdate"
              type="button"
              class="appupdate-screen__btn appupdate-screen__btn--outline"
              @click="handleLater"
            >
              لاحقًا
            </button>
          </div>

          <p v-if="update.state.forceUpdate" class="appupdate-screen__hint">
            هذا التحديث إلزامي للاستمرار في استخدام المنصة.
          </p>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import AppUpdateManager, { appUpdateState } from '@/services/AppUpdateManager';

export default {
  name: 'AppUpdateScreen',
  data() {
    return {
      update: { state: appUpdateState },
    };
  },
  methods: {
    handleUpdate() {
      AppUpdateManager.openUpdate();
    },
    handleLater() {
      AppUpdateManager.dismissOptional();
    },
  },
};
</script>

<style scoped>
.appupdate-screen {
  position: fixed;
  inset: 0;
  z-index: 1000000; /* above the offline screen */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  background: linear-gradient(160deg, #ffffff 0%, #f2f8fb 55%, #e7f2f7 100%);
  text-align: center;
}

.appupdate-screen__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 440px;
  width: 100%;
}

.appupdate-screen__logo {
  max-width: 190px;
  width: 100%;
  height: auto;
  margin-bottom: 1.25rem;
}

.appupdate-screen__emoji {
  font-size: 3rem;
  line-height: 1;
  margin-bottom: 1rem;
}

.appupdate-screen__title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #16323e;
  margin: 0 0 0.75rem;
}

.appupdate-screen__subtitle {
  font-size: 1rem;
  line-height: 1.9;
  color: #56717d;
  margin: 0 0 1.75rem;
}

.appupdate-screen__versions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  width: 100%;
}

.appupdate-screen__version {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 120px;
}

.appupdate-screen__version-label {
  font-size: 0.8rem;
  color: #8ba3ac;
}

.appupdate-screen__version-value {
  font-size: 1.25rem;
  font-weight: 700;
  padding: 0.4rem 0.75rem;
  border-radius: 0.5rem;
}

.appupdate-screen__version-value--old {
  color: #b23a48;
  background: #fdeef0;
}

.appupdate-screen__version-value--new {
  color: #1f7a4d;
  background: #e9f7ef;
}

.appupdate-screen__version-arrow {
  font-size: 1.5rem;
  color: #8ba3ac;
}

.appupdate-screen__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
}

.appupdate-screen__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 170px;
  padding: 0.8rem 1.5rem;
  border-radius: 0.6rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  border: 1px solid var(--primary-color, #2a8bb1);
}

.appupdate-screen__btn--primary {
  background-color: var(--primary-color, #2a8bb1);
  color: #fff;
}

.appupdate-screen__btn--primary:hover {
  background-color: transparent;
  color: var(--primary-color, #2a8bb1);
}

.appupdate-screen__btn--outline {
  background-color: transparent;
  color: var(--primary-color, #2a8bb1);
}

.appupdate-screen__btn--outline:hover {
  background-color: var(--primary-color, #2a8bb1);
  color: #fff;
}

.appupdate-screen__hint {
  margin: 1.25rem 0 0;
  font-size: 0.825rem;
  color: #8ba3ac;
}

.appupdate-fade-enter-active,
.appupdate-fade-leave-active {
  transition: opacity 0.3s ease;
}
.appupdate-fade-enter-from,
.appupdate-fade-leave-to {
  opacity: 0;
}
</style>
